/* eslint-disable @typescript-eslint/unbound-method */
import { createContext, useContext } from "react";
import { IFeatureFlagsService } from "../../../services/featureFlags";
import { FeatureFlagName } from "../../../utils/featureFlagName";


export class FeatureFlagContextType {
    constructor (public featureFlagsService: IFeatureFlagsService) {}

    isEnabled(flagName: FeatureFlagName) {
        return this.featureFlagsService.hasFeatureFlag(flagName);
    }
}

export const FeatureFlagContext = createContext<FeatureFlagContextType | undefined>(undefined);

export const useFeatureFlagContext = (): FeatureFlagContextType => {
    const context = useContext(FeatureFlagContext);
    if (!context) {
        throw new Error("useContext returned an undefined context for the FeatureFlagsContext");
    }
    return context;
};